import React, { createContext, useState, useContext } from "react";

const MobileWidgetContext = createContext(null);

export const MobileWidgetProvider = ({ children }) => {
  const [activeMobileWidget, setActiveMobileWidget] = useState(null); // 'ai', 'feedback', or null

  const setActiveWidget = (widgetType) => {
    setActiveMobileWidget(widgetType);
  };

  const clearActiveWidget = () => {
    setActiveMobileWidget(null);
  };

  const isAIWidgetActive =
    activeMobileWidget === "ai" || activeMobileWidget === "leo";
  const isFeedbackWidgetActive = activeMobileWidget === "feedback";

  const contextValue = {
    activeMobileWidget,
    setActiveWidget,
    clearActiveWidget,
    isAIWidgetActive,
    isFeedbackWidgetActive,
  };

  return (
    <MobileWidgetContext.Provider value={contextValue}>
      {children}
    </MobileWidgetContext.Provider>
  );
};

export const useMobileWidgetContext = () => {
  const context = useContext(MobileWidgetContext);
  if (!context) {
    throw new Error(
      "useMobileWidgetContext must be used within a MobileWidgetProvider"
    );
  }
  return context;
};
